import { PackageInformation, UserDevice, UserFavorite, UserFavoriteSearch, UserPackage, UserPackageSummary } from "src/models";

export type ProfileData = {
    packageSummaries: {
        loading: boolean;
        firstLoad: boolean;
        packages: UserPackageSummary[];
        sitePackages: PackageInformation[]
    },
    packages: {
        list: UserPackage[],
        loading: boolean;
        offset: number;
        count: number;
        hasMore: boolean;
        totalRecords: number;
        firstLoad: boolean;
    },
    devices: {
        list: UserDevice[];
        page: number;
        pages: number;
        loading: boolean;
        firstLoad: boolean;
    },
    deviceToTerminate: {
        currentDevice?: boolean;
        onSuccessCallback?: Function;
        sendingSms: boolean;
        seningRequest: boolean;
        message: string;
        seconds: number;
        phone: string;
    },
    favorites: {
        list: UserFavorite[];
        loading: boolean;
        editingFavorite?: UserFavorite;
        searchItems: UserFavoriteSearch[];
        actionLoading: boolean;
        searchLoading: boolean;
    }
};

export const ProfileDataInitialState: ProfileData = {
    packageSummaries: {
        loading: true,
        firstLoad: true,
        packages: [],
        sitePackages: []
    },
    packages: {
        list: [],
        loading: false,
        offset: 0,
        count: 10,
        hasMore: true,
        totalRecords: 0,
        firstLoad: true
    },
    devices: {
        firstLoad: true,
        loading: false,
        list: [],
        page: 1,
        pages: 1
    },
    deviceToTerminate: {
        sendingSms: true,
        seningRequest: false,
        message: "",
        seconds: -1,
        phone: "",
    },
    favorites: {
        actionLoading: false,
        list: [],
        loading: true,
        searchItems: [],
        searchLoading: false,
    },
};